import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { ModelService } from '../services/model.service';

@Injectable({
	providedIn: 'root'
})
export class AdminGuard implements CanActivate {
	constructor(
		private modelService: ModelService,
		private router: Router
	) {}

	/* https://www.sebastianbauer.dev/2019/08/16/proteger-tus-vistas-con-angular-y-sus-guards/

		Los guards son métodos que nos permiten acceder a cierta rutas, dependiendo de la condición que nosotros queramos,
		también se podrían utilizar para evitar cargar modulos, etc. Allí podemos hacer validaciones, llamar al backend o
		cualquier cosa que necesitemos. Dentro de todo lo que son los guards, existen 5 tipos:

		1.- CanActivate: Según una condición, que nosotros queramos, ingresamos a la ruta o página.
		2-. CanActivateChild: Funciona de la misma manera que CanActivate, la única diferencia es que se utiliza para rutas hijas (lazy loading).
		3.- CanDeactivate: Es lo opuesto a CanActivate, según una condición, nos permite salir de una ruta o una página. Se puede utilizar por ejemplo,
			cuando tenemos un formulario y queremos preguntar si desea descartar los cambios del mismo.
		4.- CanLoad: Lo podemos utilizar para evitar al usuario cargar módulos innecesarios.
		5.- Resolve: Podríamos utilizarlo para retrasar la representación de un componente deseado hasta que se hayan obtenido los resultados necesarios.
	*/
	public canActivate(): boolean {
		if (this.modelService.getUser().isTokenValid) {
			if (this.modelService.getUser().authToken && this.modelService.getUser().isAdmins) return true;
		}
		this.router.navigate(['/login']);
		return false;
	}

}